/** Helpers thuần cho dashboard Nhập hàng (không phụ thuộc React) — dễ test. */

export type TrendPoint = { date: string; order_count: number; invoice_value: number };
/** key = định danh ổn định (YYYY-MM hoặc YYYY-MM-DD); label = nhãn hiển thị. */
export type TrendBucket = { key: string; label: string; order_count: number; invoice_value: number };

/** Ngày theo lịch Asia/Ho_Chi_Minh (UTC+7, không DST). */
export function vnCalendar(now: Date = new Date()): { year: number; month: number; day: number } {
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60_000;
  const vn = new Date(utcMs + 7 * 3_600_000);
  return { year: vn.getFullYear(), month: vn.getMonth() + 1, day: vn.getDate() };
}

function ymd(y: number, m: number, d: number): string {
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}

/** Tháng dạng số 1..12 → khoảng ngày inclusive (ngày cuối tháng thật). */
export function monthRange(year: number, month: number): { from: string; to: string } {
  // Ngày 0 của tháng kế tiếp = ngày cuối tháng hiện tại (UTC an toàn cho số học lịch).
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return { from: ymd(year, month, 1), to: ymd(year, month, last) };
}

export function currentMonthRange(now: Date = new Date()): { from: string; to: string } {
  const { year, month } = vnCalendar(now);
  return monthRange(year, month);
}

export function previousMonthRange(now: Date = new Date()): { from: string; to: string } {
  const { year, month } = vnCalendar(now);
  return month === 1 ? monthRange(year - 1, 12) : monthRange(year, month - 1);
}

/** Gom trend theo tháng (YYYY-MM) khi khoảng dài; giữ thứ tự tăng dần. */
export function groupTrendByMonth(trend: readonly TrendPoint[]): TrendBucket[] {
  const map = new Map<string, TrendBucket>();
  for (const p of trend) {
    const key = String(p.date || "").slice(0, 7);
    if (!/^\d{4}-\d{2}$/.test(key)) continue;
    const cur = map.get(key);
    if (cur) {
      cur.order_count += Number(p.order_count) || 0;
      cur.invoice_value += Number(p.invoice_value) || 0;
    } else {
      map.set(key, {
        key,
        label: key,
        order_count: Number(p.order_count) || 0,
        invoice_value: Number(p.invoice_value) || 0,
      });
    }
  }
  return [...map.values()].sort((a, b) => a.key.localeCompare(b.key));
}

/** Theo từng ngày: key = ngày đầy đủ (ổn định qua nhiều năm), label = MM-DD. */
export function bucketTrendByDay(trend: readonly TrendPoint[]): TrendBucket[] {
  const map = new Map<string, TrendBucket>();
  for (const p of trend) {
    const key = String(p.date || "").slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) continue;
    const cur = map.get(key);
    if (cur) {
      cur.order_count += Number(p.order_count) || 0;
      cur.invoice_value += Number(p.invoice_value) || 0;
    } else {
      map.set(key, {
        key,
        label: key.slice(5),
        order_count: Number(p.order_count) || 0,
        invoice_value: Number(p.invoice_value) || 0,
      });
    }
  }
  return [...map.values()].sort((a, b) => a.key.localeCompare(b.key));
}
